<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
    <v-layout column fill-height style="height:100%;">
      <div style="width:100%;height:40px;display:flex;align-items:center;">
        <div class="breadcrumb-cont" v-for="(item,index) in breadCrumbList" v-bind:key="item" style="display:flex;align-items:center;">
          <div class="titleBtn" v-if="index>0">></div>
          <v-btn flat class="titleBtn" v-if="item=='Engine View'" v-on:click="btnClick(item)">{{ selEngine }}</v-btn>
          <v-btn flat class="titleBtn" v-else v-on:click="btnClick(item)">Overview</v-btn>
        </div>
      </div>
      <EnginesOverview
          v-show="screen=='Engines Overview'"
          class="tabItem"
          v-bind:engTypeData="engTypeData"
          v-bind:active="screen=='Engines Overview'"
      />
      <EngineView
          v-show="screen=='Engine View'"
          class="tabItem"
          @vesselSelected="onVessSelect"
          v-bind:active="screen=='Engine View'"
          v-bind:selEngine="selEngine"
          v-bind:engineData="engTypeData[selEngine]"
      />
    </v-layout>
  </v-container>
</template>

<script>
import EnginesOverview from "./EnginesOverview"
import EngineView from "./EngineView"
import {store} from "../main.js"

export default {
  name: "Engines",
  components: {
    EnginesOverview,
    EngineView
  },
  data() {
    return {
      screen: '',
      breadCrumbList: ['Engines Overview'],
      selEngine: '',
    }
  },
  computed: {
    dataLoaded: function () {
      return store.type;
    },
    engTypeData: function () {
      return store.engineAggr;
    }
  },
  created() {
  },
  mounted() {
    this.handleGetParameters();
  },
  methods: {
    handleGetParameters: function () {
      if (
          'eng' in this.$route.params
          && !!this.$route.params['eng']
      ) {
        this.selEngine = this.$route.params['eng'];

        if (this.breadCrumbList.indexOf('Engine View') < 0) {
          this.breadCrumbList.push('Engine View');
        }

        this.screen = 'Engine View';
      } else {
        this.screen = 'Engines Overview';
      }
    },
    onVessSelect: function (vessel) {
      window.$cookies.set('vessel', vessel);
      let vessel_url = new URL(store.config.ship_co)
      vessel_url.pathname += `vessel-view/${vessel}`
      window.open(vessel_url.toString());
    },
    btnClick: function (item) {
      if (this.breadCrumbList.includes(item)) {
        let index = this.breadCrumbList.indexOf(item);

        this.breadCrumbList = this.breadCrumbList.slice(0, index + 1);
      } else {
        this.breadCrumbList.push(item);
      }

      if (this.screen != item) {
        this.$router.push({'path': '/engines'})
      }
    }
  },
  watch: {
    screen: function (screen) {
      if (screen.toLowerCase().indexOf('overview') > -1) {
        this.breadCrumbList = this.breadCrumbList.slice(0, 1);
      }
    },
    "$route.params": {
      handler: function () {
        this.handleGetParameters()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.tabItem {
  max-height: calc(100% - 40px)
}
</style>

<style>
.breadcrumb-cont .titleBtn {
  font-size: 12px !important;
  text-transform: none;

  margin-right: -5px !important;
  margin-left: -5px !important;
}
</style>
